// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import styled from 'styled-components'
import includes from 'lodash/includes'
import isEmpty from 'lodash/isEmpty'
import { displayStatus, pluralize } from '../../utils'
import { User } from '../../types'
import { alert } from '../../actions/alert'
import { createFavorite, deleteFavorite } from '../../actions/user'
import Card from '../Card'
import FavoriteButton from '../FavoriteButton'
import colors from '../../styles/colors'
import StatusTag from '../StatusTag'

const ImageLink = styled(Link)`
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`

const BottomRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const FavoriteButtonContainer = styled.div`
  flex-shrink: 0;
  align-self: flex-end;
`

type Props = {
  user: User,
  alert: Function,
  property: Object,
  createFavorite: Function,
  deleteFavorite: Function,
  isAuthenticated: boolean,
  favorites: Array<{ id: number, mls_id: number }>
}

class PropertyCard extends Component {
  props: Props

  handleCreateFavorite = () =>
    this.props.createFavorite(this.props.user.id, this.props.property.mlsId)

  handleDeleteFavorite = () =>
    this.props.deleteFavorite(this.props.user.id, this.props.property.mlsId)

  handleUnauthenticatedFavorite = () =>
    this.props.alert({
      message: 'Please login to save favorites',
      klass: 'primary',
      timeout: 4000
    })

  render() {
    const { property, favorites } = this.props
    if (isEmpty(property)) return null
    const favoriteMlsIds = favorites.map((favorite) => favorite.mls_id)

    return (
      <Card>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <ImageLink to={`/properties/${property.mlsId}`}>
              {property.photos && property.photos.length ? (
                <img
                  src={property.photos[0]}
                  role="presentation"
                  style={{ width: '100%' }}
                />
              ) : (
                <img
                  src="/static/images/default-home-marker.png"
                  role="presentation"
                  style={{ width: '100%' }}
                />
              )}
              <StatusTag status={property.mls.status}>
                {displayStatus(property.mls.status)}
              </StatusTag>
            </ImageLink>
          </div>
          <div className="col-md-6 col-xs-12">
            <div style={{ marginBottom: '10px' }}>
              <Link
                to={`/properties/${property.mlsId}`}
                style={{ color: 'inherit' }}
              >
                <div>{property.address.full}</div>
              </Link>
              <div>
                <small style={{ color: 'rgb(120,130,140)' }}>
                  {property.address.city}, {property.address.state}{' '}
                  {property.address.postalCode}
                </small>
              </div>
            </div>
            <div>
              <span style={{ color: colors.success, marginRight: '5px' }}>
                ${Number(property.listPrice).toLocaleString()}
              </span>
              <span className="fa fa-home" style={{ marginRight: '5px' }} />
              <span style={{ marginRight: '5px' }}>
                {property.property.bedrooms} bd
              </span>
              <span style={{ marginRight: '5px' }}>
                {property.property.bathrooms} ba
              </span>
              <span>{Number(property.property.area).toLocaleString()} sf</span>
            </div>
            {property.remarks && (
              <div>
                <hr />
                <div style={{ fontSize: '13px' }}>
                  {property.remarks && property.remarks.slice(0, 150)}
                  {property.remarks && property.remarks.length > 150 && '...'}
                </div>
              </div>
            )}
            <hr />
            <BottomRow>
              <div style={{ fontSize: '80%', marginRight: '0.5rem' }}>
                <div>
                  <span
                    className="fa fa-clock-o"
                    style={{ marginRight: '5px' }}
                  />
                  <span>
                    {property.mls.daysOnMarket}{' '}
                    {pluralize(property.mls.daysOnMarket, 'day')} on the market
                  </span>
                </div>
                <div>Listing courtesy of {property.office.name}</div>
              </div>
              <FavoriteButtonContainer>
                <FavoriteButton
                  onCreate={this.handleCreateFavorite}
                  onDelete={this.handleDeleteFavorite}
                  isAuthenticated={this.props.isAuthenticated}
                  isFavorite={includes(favoriteMlsIds, property.mlsId)}
                  onUnauthenticatedClick={this.handleUnauthenticatedFavorite}
                />
              </FavoriteButtonContainer>
            </BottomRow>
          </div>
        </div>
      </Card>
    )
  }
}

export default connect(
  (state) => ({
    user: state.session.currentUser,
    favorites: state.user.favorites,
    isAuthenticated: state.session.isAuthenticated
  }),
  {
    alert,
    createFavorite,
    deleteFavorite
  }
)(PropertyCard)



// WEBPACK FOOTER //
// ./src/components/PropertyCard/index.js